export default "__VITE_ASSET__C1cr$Aju__"